<template>
  <div class="profile-banner" :style="{'background-image': 'url(' + pet_banner + ')'}">
    <div class="banner-overlay"></div>
    <!-- <div class="tag-assigned" @click="displayTagNotice()">
      <img :src="checked_icon" v-if="tag_links.length > 0" />
      <img :src="caution_icon" v-else/>
    </div>
    <div class="tag-notice" v-if="showTagNotice">
      <p v-if="tag_links.length > 0" >Your profile is assigned to a tag</p>
      <p v-else>Your profile is unassigned to a tag</p>
    </div> -->
      <input
      class="profile-banner-input"
        type="file"
        accept="image/jpeg, image/png, image/gif"
        @change="selectBannerFile"
        v-if="show_Bedit && editablePage" />
        <img src="@/assets/petprofile/interactions/upload.svg" class="profile-banner-input-img" v-if="editablePage"/>

    <!-- <img class="overlay" src="@/assets/gfx/petselection.svg" > -->
    <div id="grad">
    </div>

  </div>
</template>
<script>
import {fb, db} from '@/_firebase/init'
export default{
  props:['pet_banner', 'editablePage', 'tag_links', 'pet_id'],
  data(){
    return{
      // pet_banner: 'https://firebasestorage.googleapis.com/v0/b/petproject-qbelnc.appspot.com/o/site_assets%2Fdefault-wagtag-banner.jpg?alt=media&token=e223ed77-531c-497e-893e-fbd3f7394f07',
      show_Bedit: true,
      showTagNotice: false,
      // checked_icon: require('@/assets/svg/checked.svg'),
      // caution_icon: require('@/assets/svg/caution.svg'),
    }
  },
  methods:{
    displayTagNotice(){
      this.showTagNotice = !this.showTagNotice
    },
    async addPetBanner(pic){
      const petRef = db.collection('pets').doc(this.pet_id);
      const res = await petRef.update({banner: pic});
      return res
    },
    selectBannerFile(evt){
          let file = evt.target.files[0];
          var storeRef = fb.storage().ref('/pet_profile_media/banners/'+file.name);
          let uploadTask = storeRef.put(file);
          uploadTask.on('state_changed', () =>{
          },(err) => {
            console.log(err);
          },() => {
            uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
              this.pet_banner = downloadURL;
              this.addPetBanner(downloadURL)
              // this.updateBannerPhoto(downloadURL)
            });
          })
        },
  },
}
</script>
<style scoped>
/*----------------------*\
|     PROFILE BANNERS
\*----------------------*/
.profile-banner{
  width:100%;
  min-height: 305px;
  overflow:hidden;
  position: relative;
  margin-top: -2rem;
  /* Create the parallax scrolling effect */
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  text-align: center;
  /* box-shadow: 0 0px 0 0 white inset, -0 -0 50px 0 white inset; */
}
.banner-overlay{
  position: absolute;
  background-color: #000;
  opacity: .1;
  top:0;
  left:0;
  height: 100%;
  width:100%;
  z-index:1;
}
#grad {
  height: 100%;
  position: absolute;
  width: 100%;
  /* max-height: ; */
  bottom: 0;
  /* background-image: linear-gradient(to bottom, rgba(255,255,255,0), rgba(255,255,255, 1)); */
}
.profile-data{
  top: 1rem;
  position: absolute;
  z-index: 2;
  left:25%;
  width: 50%;
  right: 25%;
  transition: 1s;
}
.profile-banner-input{
  cursor: pointer;
  opacity:0;
  z-index: 7;
  transition: 1s;
  position: absolute;
  z-index: 3;
  top: 3rem;
  right: 1.2rem;
  width: 2rem;
  height: 2rem;
  border: 2px solid #efe;
}
.profile-banner-input-img{
  transition: 1s;
  position: absolute;
  z-index: 6;
  z-index: 2;
  top: 3rem;
  right: -.7rem;
  width: 6rem;
  height: 2rem;
}
.profile-banner-input-img:hover{
  cursor: pointer;
}
.tag-assigned{
  z-index: 4;
  width: 2rem;
  cursor:pointer;
  position: absolute;
  top: 1rem;
  right: 1rem;
}
.tag-assigned img{
  width: 100%;
}
.tag-notice{
  position: absolute;
  z-index: 8;
  max-width: 10rem;
  top: 1rem;
  padding: .5rem;
  font-size: .7rem;
  right: 3rem;
  background: #fff;
  border-radius: 10px;
}
/*----------------------*\
|     PROFILE BANNER END
\*----------------------*/
@media only screen and (max-width: 600px) {
  .tag-assigned{
    z-index: 4;
    top: .5rem;
    width: 1.5rem;
  }
  .profile-banner-input{
    bottom: .3rem;
    right: .9rem;
    width: 1.5rem;
    height: 1.5rem;
  }
  .profile-banner-input-img{
    bottom: .3rem;
    right: 1rem;
    width: 1.5rem;
    height: 1.5rem;
  }
}
</style>
